import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../../Components/Buttons/Custom";
import DemoModal from "../../Purchase/Components/DemoModal";
import { API_BASE_URL } from "../../../config/api";
import useInfinitePaginated from "../../../hooks/useInfinitePaginated";

export default function Buttons({ setModalClosed }) {
  const navigate = useNavigate();
  const { search } = useLocation();
  const shouldOpenDemo = new URLSearchParams(search).get("next") === "demo";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openedFromNext, setOpenedFromNext] = useState(false);
  const demoPagination = useInfinitePaginated({
    endpoint: `${API_BASE_URL}landing/challenges/demo/`,
    navigate,
    enabled: isModalOpen,
    select: (response) => Array.isArray(response?.results) ? response.results : [],
    merge: (current, incoming) => {
      const seen = new Set(current.map((item) => item?.id ?? item?.uuid));
      return [...current, ...incoming.filter((item) => {
        const key = item?.id ?? item?.uuid;
        if (key == null || seen.has(key)) return false;
        seen.add(key);
        return true;
      })];
    },
  });

  useEffect(() => {
    if (shouldOpenDemo && !openedFromNext) {
      setIsModalOpen(true);
      setOpenedFromNext(true);
    }
  }, [shouldOpenDemo, openedFromNext]);

  return (
    <div className="w-full flex gap-2.5 items-center justify-end">
      <CustomButton onClick={() => setIsModalOpen(true)} text="شروع چالش تمرینی" className="w-full max-w-48 border border-zi-border-dark bg-zi-bg2-light dark:bg-zi-bg2-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-inset hocus:ring-1 hocus:ring-zi-border-dark" />
      <CustomButton text="شروع چالش جدید" className="w-full max-w-48 bg-zi-gradient-button-blue text-zi-text-dark hocus:ring-offset-1 hocus:ring-1 hocus:ring-zi-blue-light" textShadow onClick={() => navigate("/purchase")} />
      {isModalOpen && (
        <div className="w-full h-full min-h-0 fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={() => setIsModalOpen(false)}>
          <div className="w-11/12 max-w-lg max-h-full" onClick={(event) => event.stopPropagation()}>
            <DemoModal setModalClosed={setModalClosed} onClose={() => setIsModalOpen(false)} accountData={demoPagination.data} demoPagination={demoPagination} />
          </div>
        </div>
      )}
    </div>
  );
}
